import { cn } from '~/utils/tailwind-utils'

interface TempoIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const TempoIcon: React.FC<TempoIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 400 400"
      fill="none"
      className={cn(colored && 'fill-[#33312E] dark:fill-white', className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M156.324 353H72.6313L150.201 116.355H51L72.6313 47H349L327.369 116.355H233.48L156.324 353Z"
        fill={colored ? undefined : 'currentColor'}
      />
    </svg>
  )
}
